import type { MotionValue } from "motion";

export function connectScrollVelocityInput(
  target: MotionValue<number>,
  source: MotionValue<number> | null,
  subscribe: (_update: (_y: number) => void) => () => void
) {
  if (source) {
    // Mounting at a restored scroll position must not manufacture velocity.
    target.jump(source.get());
    return source.on("change", (y) => target.set(y));
  }
  return subscribe((y) => target.set(y));
}
